<template>
  <el-alert
    v-if="pendingRevision"
    title="Revision"
    show-icon
    :closable="false"
    type="warning"
  >
    <span
      >You are editing page revision. Changes will not be published until you
      submit this form.</span
    >
  </el-alert>
</template>

<script>
export default {
  props: {
    pendingRevision: {
      type: Object,
      required: false
    }
  }
}
</script>
